// extracted by mini-css-extract-plugin
module.exports = {"container":"Signup_container__joyQQ","logo":"Signup_logo__O3w8a","signin":"Signup_signin__u4xEs"};